import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CampaignIcon from '@mui/icons-material/Campaign';
import { Title } from 'react-admin';
import { getApiUrl } from '../utils/apiUrl';

const apiUrl = getApiUrl();

const getToken = () => localStorage.getItem('admin_token');

const HoaMessaging: React.FC = () => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (!message.trim()) return;

    setSending(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${apiUrl}/api/v1/admin/broadcast`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message: message.trim() }),
      });

      if (response.ok) {
        const result = await response.json();
        setSuccess(
          `Message sent to ${result.sent_count} user${result.sent_count !== 1 ? 's' : ''}`
        );
        setMessage('');
      } else {
        const errData = await response.json().catch(() => null);
        setError(errData?.detail || 'Failed to send message');
      }
    } catch (err) {
      setError('Network error — could not send message');
    } finally {
      setSending(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 700, mx: 'auto' }}>
      <Title title="Broadcast Message" />
      <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CampaignIcon fontSize="large" />
        Broadcast Message
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
        Send a message to all NeverKnock users. The message will appear in
        each user's inbox.
      </Typography>

      <Card>
        <CardContent>
          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          <TextField
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            multiline
            rows={5}
            placeholder="Type your message to all users..."
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            onClick={handleSend}
            disabled={!message.trim() || sending}
            startIcon={
              sending ? <CircularProgress size={18} /> : <SendIcon />
            }
            size="large"
          >
            {sending ? 'Sending...' : 'Send to All Users'}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default HoaMessaging;
